'use strict';

const _ = require('lodash');
const {PARSER_ERRORS} = require('../constants');
const ParserError = require('../errors/ParserError');
const yup = require('yup');

const geoSchema = yup.object().shape({
    lat: yup.number().required(),
    lng: yup.number().required(),
    country: yup.string(),
    adm1: yup.string(),
    adm2: yup.string(),
    adm3: yup.string(),
    postalCode: yup.string(),
});

const cast = (input) => {
    try {
        return geoSchema.validateSync(input, {stripUnknown: true});
    } catch (err) {
        return false;
    }
};

module.exports = (input, config) => {
    _.defaults(config, {});

    input = cast(input);

    if (config.required && !input) {
        throw new ParserError(PARSER_ERRORS.REQUIRED);
    }

    return input || undefined;
};
